import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconRemoveLine = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 17,
	height: 16,
	viewBox: "0 0 17 16",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.16732 7.33301V8.66634H11.834V7.33301H5.16732ZM8.50065 1.33301C4.82065 1.33301 1.83398 4.31967 1.83398 7.99967C1.83398 11.6797 4.82065 14.6663 8.50065 14.6663C12.1807 14.6663 15.1673 11.6797 15.1673 7.99967C15.1673 4.31967 12.1807 1.33301 8.50065 1.33301ZM8.50065 13.333C5.56065 13.333 3.16732 10.9397 3.16732 7.99967C3.16732 5.05967 5.56065 2.66634 8.50065 2.66634C11.4407 2.66634 13.834 5.05967 13.834 7.99967C13.834 10.9397 11.4407 13.333 8.50065 13.333Z",
		fill: "#959595"
	})
});
export default SvgIconRemoveLine;
